import { OrderStatus } from '@/types';
import { ORDER_STATUS_COLORS } from '@/utils';

interface Props {
  status: OrderStatus;
  className?: string;
}

const STATUS_LABELS: Record<OrderStatus, string> = {
  PENDING: 'Pending',
  CONFIRMED: 'Confirmed',
  PROCESSING: 'Processing',
  SHIPPED: 'Shipped',
  DELIVERED: 'Delivered',
  CANCELLED: 'Cancelled',
  REFUNDED: 'Refunded',
};

export const OrderStatusBadge = ({ status, className = '' }: Props) => (
  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${ORDER_STATUS_COLORS[status]} ${className}`}>
    {STATUS_LABELS[status]}
  </span>
);
